import { IsMobilePhone, Length, Matches } from 'class-validator';

import { phoneRegexp } from '@onArte/shared/regexp';

export class UserUpdateModel {
  @Length(2, 64)
  public firstName: string;

  @Length(2, 128)
  public lastName: string;

  @Length(9, 12)
  @Matches(phoneRegexp)
  @IsMobilePhone()
  public phone: string;

  @Length(2, 128)
  public hash: string;
}
